import { MappedAreaModel } from "../models/mapped-area-model";

export class PlanPresenter {
  private readonly _inlineSvg: string;

  constructor(floor: MappedAreaModel) {
    this._inlineSvg = floor.planSvg;
  }

  get inlineSvg(): string {
    return this._inlineSvg
      .replace('<style type="text/css" id="cssThem"><![CDATA[]]></style>', "")
      .replace('<script type="text/ecmascript">', '<script type="text/ecmascript" id="svg_inf">')
      .replace(' onload="svgLoad(evt)"', "")
      .replace(' onload="svgLoad(evt);"', "")
      .replace(' onunload="svgUnload(evt)"', "")
      .replace(' onunload="svgUnload(evt);"', "")
      .replace(' onerror="svgError(evt)"', "")
      .replace(' onerror="svgError(evt);"', "")
      .replace("<svg", '<svg height="100%" width="100%"')
      .replace(/ begin="dessin([^"]*)"/, "");
  }
}
